import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GridModule, SortService } from '@syncfusion/ej2-angular-grids';
import { TopBarComponent } from '../top-bar/top-bar.component';
import { OpsVendorRentals } from '../operations/ops-vendors/ops-vendor-rentals/ops-vendor-rentals';
import { OpsVendorDashboard } from '../operations/ops-vendors/ops-vendor-details/ops-vendor-dashboard/ops-vendor-dashboard';
import { OpsVendorHistory } from '../operations/ops-vendors/ops-vendor-details/ops-vendor-history/ops-vendor-history';
import { OpsVendorInfo } from '../operations/ops-vendors/ops-vendor-details/ops-vendor-info/ops-vendor-info';
import { OpsVendorNotes } from '../operations/ops-vendors/ops-vendor-details/ops-vendor-notes/ops-vendor-notes';
import { OpsVendorSettings } from '../operations/ops-vendors/ops-vendor-details/ops-vendor-settings/ops-vendor-settings';
import { OperationsComponent } from '../operations/operations.component';
import { OpsVendorDailyRental } from '../operations/ops-vendors/ops-vendor-rentals/ops-vendor-daily-rental/ops-vendor-daily-rental';
import { OpsVendorMonthlyRental } from '../operations/ops-vendors/ops-vendor-rentals/ops-vendor-monthly-rental/ops-vendor-monthly-rental';
import { OpsVendorWeeklyRental } from '../operations/ops-vendors/ops-vendor-rentals/ops-vendor-weekly-rental/ops-vendor-weekly-rental';
import { DatePickerModule, TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { OpsVendorContracts } from '../operations/ops-vendors/ops-vendor-details/ops-vendor-contracts/ops-vendor-contracts';
import { OpsVendorPosDiscountPlans } from '../operations/ops-vendors/ops-vendor-details/ops-vendor-pos-discount-plans/ops-vendor-pos-discount-plans';
import { OpsVendorAttachments } from '../operations/ops-vendors/ops-vendor-details/ops-vendor-attachments/ops-vendor-attachments';
import { OpsCreateVendor } from '../operations/ops-vendors/ops-vendor-details/ops-createupdate-vendor/ops-createupdate-vendor';
import { OpsSalesPerson } from '../operations/ops-maintenance/ops-sales-person/ops-sales-person';
import { OpsPrinterSettings } from '../operations/ops-maintenance/ops-maintenance-settings/ops-printer-settings/ops-printer-settings';
import { OpsPosSettings } from '../operations/ops-maintenance/ops-maintenance-settings/ops-pos-settings/ops-pos-settings';
import { OpsVendorSettingsMaintenance } from '../operations/ops-maintenance/ops-maintenance-settings/ops-vendor-settings/ops-vendor-settings';
import { OpsOtherCharges } from '../operations/ops-maintenance/ops-other-charges/ops-other-charges';
import { OpsAutomaticRentalRenewal } from '../operations/ops-vendors/ops-automatic-rental-renewal/ops-automatic-rental-renewal';
import { OpsViewLayout } from '../operations/ops-vendors/ops-view-layout/ops-view-layout';
import { OpsProduct } from '../operations/ops-maintenance/ops-product/ops-product';
import { OpsProductCategory } from '../operations/ops-maintenance/ops-product-category/ops-product-category';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { SelectTemplateComponent } from './select-template/select-template.component';
import { PointOfSales } from '../point-of-sales/point-of-sales';
import { PosSalesDetails } from '../point-of-sales/pos-sales-details/pos-sales-details';
import { OpsMarketInformation } from '../operations/ops-maintenance/ops-market-information/ops-market-information';
import { OpsDeleteRental } from '../operations/ops-vendors/ops-vendor-rentals/ops-delete-rental/ops-delete-rental';
import { OpsEmailTemplates } from '../operations/ops-maintenance/ops-email-templates/ops-email-templates';
import { OpsCreditDebitCards } from '../operations/ops-maintenance/ops-credit-debit-cards/ops-credit-debit-cards';
import { OpsConsignmentInventory } from '../operations/ops-point-of-sales/ops-consignment-inventory/ops-consignment-inventory';
import { OpsLayoutParts } from '../operations/ops-maintenance/ops-layout-parts/ops-layout-parts';
import { OpsOnlinePaymentSettings } from '../operations/ops-maintenance/ops-maintenance-settings/ops-online-payment-settings/ops-online-payment-settings';
import { OpsVendorAdjustments } from '../operations/ops-point-of-sales/ops-vendor-adjustments/ops-vendor-adjustments';
import { OpsOpeningCashDrawerAmount } from '../operations/ops-point-of-sales/ops-opening-cash-drawer-amount/ops-opening-cash-drawer-amount';
import { OpsPosTerminals } from '../operations/ops-maintenance/ops-pos-terminals/ops-pos-terminals';
import { OpsDepositSlip } from '../operations/ops-vendors/ops-deposit-slip/ops-deposit-slip';
import { OpsBoothHistory } from '../operations/ops-vendors/ops-booth-history/ops-booth-history';
import { OpsVoidTransaction } from '../operations/ops-vendors/ops-void-transaction/ops-void-transaction';
import { OpsGiftCertificates } from '../operations/ops-point-of-sales/ops-gift-certificates/ops-gift-certificates';
import { OpsDayEndProcess } from '../operations/ops-point-of-sales/ops-day-end-process/ops-day-end-process';
import { OpsVenEmail } from '../operations/ops-vendors/ops-ven-email/ops-ven-email';
import { OpsCheckSetup } from '../operations/ops-point-of-sales/ops-check-setup/ops-check-setup';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { OpsCheckLayout } from '../operations/ops-point-of-sales/ops-check-layout/ops-check-layout';
import { OpSharedReportComponent } from '../operations/ops-report/operational/op-shared.component';
import { OpsNewInventory } from '../operations/ops-inventory/ops-new-inventory/ops-new-inventory';
import { OpsInventory } from '../operations/ops-inventory/ops-inventory';
import { OpsStockDetails } from '../operations/ops-inventory/ops-stock-details/ops-stock-details';
import { OpsSoldItemsSearch } from '../operations/ops-point-of-sales/ops-sold-items-search/ops-sold-items-search';
import { OpsVendorsPayout } from '../operations/ops-point-of-sales/ops-vendors-payout/ops-vendors-payout';
import { OpsCheckPrinting } from '../operations/ops-point-of-sales/ops-check-printing/ops-check-printing';
import { OpsProcessAchPayment } from '../operations/ops-vendors/ops-process-ach-payment/ops-process-ach-payment';
import { OpsWiSettings } from '../operations/ops-maintenance/ops-maintenance-settings/ops-wi-settings/ops-wi-settings';

export const ANGULAR_MODULES = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
];

export const SYNCFUSION_MODULES = [
    GridModule,
    DatePickerModule,
    TimePickerModule,
    DropDownListModule,
    MaskedTextBoxModule,
    TooltipModule
];

export const GENERAL_COMPONENTS = [
    TopBarComponent
];

export const VENDOR_COMPONENTS = [
    OpsVendorRentals,
    OpsVendorDashboard,
    OpsVendorHistory,
    OpsVendorInfo,
    OpsVendorNotes,
    OpsVendorSettings,
    OpsVendorContracts,
    OpsVendorPosDiscountPlans,
    OpsVendorAttachments,
    OpsCreateVendor,
    OpsAutomaticRentalRenewal,
    OpsViewLayout,
    OpsDepositSlip,
    OpsBoothHistory,
    OpsVoidTransaction,
    OpsVenEmail,
    OpsProcessAchPayment
];

export const MAINTENANCE_COMPONENTS = [
    OpsSalesPerson,
    OpsPrinterSettings,
    OpsPosSettings,
    OpsVendorSettingsMaintenance,
    OpsOtherCharges,
    OpsProduct,
    OpsProductCategory,
    OpsMarketInformation,
    OpsEmailTemplates,
    OpsCreditDebitCards,
    OpsLayoutParts,
    OpsOnlinePaymentSettings,
    OpsPosTerminals,
    OpsWiSettings
]

export const Operational_COMPONENTS = [
    OperationsComponent
];

export const Rental_COMPONENTS = [
    OpsVendorDailyRental,
    OpsVendorWeeklyRental,
    OpsVendorMonthlyRental,
    OpsDeleteRental
];

export const Pos_COMPONENTS = [
    PointOfSales,
    PosSalesDetails
];

export const OPS_PointOfSales = [
    OpsConsignmentInventory,
    OpsVendorAdjustments,
    OpsOpeningCashDrawerAmount,
    OpsGiftCertificates,
    OpsDayEndProcess,
    OpsCheckSetup,
    OpsCheckLayout,
    OpsSoldItemsSearch,
    OpsVendorsPayout,
    OpsCheckPrinting
];

export const OPS_Reports = [
    OpSharedReportComponent
];

export const OPS_Inventory = [
    OpsNewInventory,
    OpsInventory,
    OpsStockDetails
];

export const MARKET_SELECT_COMPONENT = [
    SelectTemplateComponent
];

export const SHARED_IMPORTS = [
    ...ANGULAR_MODULES,
    ...SYNCFUSION_MODULES,
    ...GENERAL_COMPONENTS,
    ...MAINTENANCE_COMPONENTS,
    ...MARKET_SELECT_COMPONENT,
    ...Pos_COMPONENTS,
    ...OPS_PointOfSales,
    ...OPS_Reports,
    ...OPS_Inventory
];

export {
    TopBarComponent,
    OpsVendorRentals,
    OpsVendorDashboard,
    OpsVendorHistory,
    OpsVendorInfo,
    OpsVendorNotes,
    OpsVendorSettings,
    OpsVendorContracts,
    OpsVendorPosDiscountPlans,
    OpsVendorAttachments,
    OperationsComponent,
    OpsVendorDailyRental,
    OpsVendorWeeklyRental,
    OpsVendorMonthlyRental,
    OpsCreateVendor,
    OpsSalesPerson,
    OpsPrinterSettings,
    OpsPosSettings,
    OpsVendorSettingsMaintenance,
    OpsOtherCharges,
    OpsAutomaticRentalRenewal,
    OpsViewLayout,
    OpsProduct,
    OpsProductCategory,
    PointOfSales,
    PosSalesDetails,
    OpsMarketInformation,
    OpsDeleteRental,
    OpsEmailTemplates,
    OpsCreditDebitCards,
    OpsConsignmentInventory,
    OpsLayoutParts,
    OpsOnlinePaymentSettings,
    OpsVendorAdjustments,
    OpsOpeningCashDrawerAmount,
    OpsPosTerminals,
    OpsDepositSlip,
    OpsBoothHistory,
    OpsVoidTransaction,
    OpsGiftCertificates,
    OpsDayEndProcess,
    OpsVenEmail,
    OpsCheckSetup,
    OpsCheckLayout,
    OpSharedReportComponent,
    OpsNewInventory,
    OpsInventory,
    OpsStockDetails,
    OpsSoldItemsSearch,
    OpsVendorsPayout,
    OpsCheckPrinting,
    OpsProcessAchPayment,
    OpsWiSettings
};
